export function multiplyIndentByWidth(indentLevel) {
	return indentLevel * 60
}
